import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { api } from "../../services/api/api";
import { WorkorderTabs } from "./tabs/machines-parts/WorkorderTabs";
import { WorkorderProvider } from "../../context/WorkorderContext";
import { t } from "i18next";
import { getCookie, setSecureCookie } from "../../services/auth/cookies";


/* Styles */
import "./Workorder.scss";
/***/

/**
 * Vue principale du workorder - utilise une approche hybride:
 * - Utilise le WorkorderProvider pour compatibilité avec le code existant
 */
export function Workorder() {
  const { id } = useParams<{ id: string }>();
  const [workorder, setWorkorder] = useState<EasyTech.Workorder | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const id = localStorage.getItem("userId");
    const userId = getCookie("userId") || id;
    
    if (userId) {
      api.get(`admin/users/${userId}`)
        .then((userData: any) => {
          if (userData && userData.roles) {
            const existingRoles = getCookie("userRoles") || "";
            const existingRolesArray = existingRoles ? existingRoles.split(",") : [];
            
            const allRoles = [...existingRolesArray];
            userData.roles.forEach((role: string) => {
              if (!allRoles.includes(role)) {
                allRoles.push(role);
              }
            });
            
            setSecureCookie("userRoles", allRoles.join(","), 60);
          }
        })
        .catch((err) => {
          console.error(t("workorder:errors:userRolesFetch"), err);
        });
    }
  }, []);

  useEffect(() => {
    const fetchWorkorder = async () => {
      if (!id) return;
      
      setLoading(true);
      try {
        const data = await api.get(`users/workorders/${id}/extended`);
        
        if (data) {
          const workorderData = data as EasyTech.Workorder;
          setWorkorder(workorderData);
        }
      } catch (err) {
        console.error(t("workorder:errors:load"), err);
        setError(t("workorder:errors:load"));
      } finally {
        setLoading(false);
      }
    };

    fetchWorkorder();
  }, [id, setWorkorder]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-600">{t("common:loading")}</p>
      </div>
    );
  }

  if (error || !workorder) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-red-600">{error || t("workorder:noData")}</p>
      </div>
    );
  }

  return (
    <WorkorderProvider value={workorder} setWorkorderState={setWorkorder}>
      <div className="p-4">
        <WorkorderTabs data={workorder} />
      </div>
    </WorkorderProvider>
  );
}
